import { Checkbox } from '@hologram-dimension/checkbox';
import { ChangeEventHandler, FC, useCallback } from 'react';
import { useSimInventorySelected } from 'state';
import { SimsDaoSim } from 'types/__generated__/SimInventoryApi';
import { SimInventorySegmentName } from 'types/common';
import { Popover } from '@hologram-dimension/popover';
import styles from './SimInventoryTableCheckbox.module.css';
import { OnAllCheckboxToggled, OnCheckboxToggled } from './SimInventoryTableShared';

interface SimInventoryCheckboxProps {
  sim: SimsDaoSim;
  segmentName: SimInventorySegmentName;
  isHeader: boolean;
  allowToggle: boolean;
  onCheckboxToggled: OnCheckboxToggled;
  onAllCheckboxToggled: OnAllCheckboxToggled;
}

const SimInventoryCheckbox: FC<SimInventoryCheckboxProps> = ({
  sim,
  segmentName,
  isHeader,
  allowToggle,
  onCheckboxToggled,
  onAllCheckboxToggled,
}) => {
  const { all: allSimsSelected, sims: selectedSims } = useSimInventorySelected(segmentName);

  const onChange = useCallback<ChangeEventHandler<HTMLInputElement>>(
    (e) => {
      const { checked } = e.target;

      if (isHeader) {
        onAllCheckboxToggled(checked);
      } else {
        onCheckboxToggled(checked, {
          hologramSimId: sim.hologramSimId!,
          claimed_device_id: sim.deviceId,
        });
      }
    },
    [isHeader, onAllCheckboxToggled, onCheckboxToggled, sim.deviceId, sim.hologramSimId]
  );

  const headerTitle = allSimsSelected === 'checked' ? 'Deselect all' : 'Select all';

  const checkbox = (
    <Checkbox
      className={styles.wrapper}
      hiddenLabel
      label={isHeader ? headerTitle : 'Select SIM'}
      title={isHeader ? headerTitle : 'Select SIM'}
      defaultChecked={
        isHeader
          ? allSimsSelected === 'checked'
          : !!sim.hologramSimId && selectedSims?.has(sim.hologramSimId)
      }
      onChange={onChange}
      indeterminate={isHeader && allSimsSelected === 'indeterminate'}
      disabled={!allowToggle}
    />
  );

  if (isHeader)
    return (
      <Popover content={headerTitle} id="select-deselect-all-checkbox" allowPinning={false}>
        {checkbox}
      </Popover>
    );
  return checkbox;
};

export default SimInventoryCheckbox;
